import { render, staticRenderFns } from "./RecordDetail.vue?vue&type=template&id=fa0fb784&scoped=true"
import script from "./RecordDetail.vue?vue&type=script&lang=js"
export * from "./RecordDetail.vue?vue&type=script&lang=js"
import style0 from "./RecordDetail.vue?vue&type=style&index=0&id=fa0fb784&prod&lang=scss&scoped=true"
import style1 from "./RecordDetail.vue?vue&type=style&index=1&id=fa0fb784&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "fa0fb784",
  null
  
)

export default component.exports